export default __webpack_public_path__ + "static/media/service3.2ff9b30e.png";